import React from "react";
import { PopoverProps, Popover, Typography, Grid, SvgIcon } from "@material-ui/core";
import CloseIconButton from "../components/CloseIconButton";
import { useStyles } from "./LargePopup.styles";
import { PrimaryButton } from "./Buttons";
import { IAddOn } from "../store/AddOn";

export interface LargePopupProps extends PopoverProps {
  imageUrl?: string;
  altText?: string;
  title?: string;
  description?: string;
  hideButton?: boolean | IAddOn | undefined;
  onButtonClick?: Function;
  buttonText?: string;
}

const releaseKeys = ["Escape", "Tab", " "];

export const LargePopup: React.FC<LargePopupProps> = (props: LargePopupProps) => {
  const classes = useStyles();

  const handleClose = (event: any) => {
    if (props.onClose) {
      props.onClose(event, "escapeKeyDown");
    }
  };

  const addButtonclick = (event: any) => {
    props.onButtonClick?.();
    handleClose(event);
  };

  return (
    <Popover
      {...props}
      anchorReference={"none"}
      classes={{
        root: classes.popover,
        paper: classes.paper,
      }}
      onKeyDown={(e: any) => {
        if (releaseKeys.includes(e.key)) handleClose(e);
      }}
    >
      <div className={classes.popup}>
        <Grid container className={classes.header} direction='row'>
          <Grid item xs={10}>
            <Typography variant='h4' className={classes.h4}>
              {props.title || ""}
            </Typography>
          </Grid>
          <Grid item xs={2} className={classes.closeIcon}>
            <CloseIconButton onClick={event => handleClose(event)} />
          </Grid>
        </Grid>
        <Grid container direction='row' className={classes.body}>
          <Grid item xs={12} sm className={classes.textBlock}>
            <div dangerouslySetInnerHTML={{ __html: props.description || "" }} className={"text-area"}></div>
            {!props.hideButton && (
              <div>
                <PrimaryButton fullWidth={false} onClick={addButtonclick} className={classes.addButton}>
                  <SvgIcon>
                    <path
                      d='M12.2089 12.2089H20.2763V11.7911H12.2089L12.2089 3.72367L11.791 3.72367V11.7911L3.7236 11.791V12.209L11.791 12.2089V20.2763L12.2089 20.2763L12.2089 12.2089Z'
                      fill='currentColor'
                      stroke='currentColor'
                    />
                  </SvgIcon>
                  <span className='button-text'>{props.buttonText}</span>
                </PrimaryButton>
              </div>
            )}
          </Grid>
          {props.imageUrl && (
            <Grid item xs={12} sm={6} className={classes.imageGrid}>
              {props.imageUrl && <img src={props.imageUrl ?? ""} alt={props.altText ?? ""} loading='lazy' className={classes.image} />}
            </Grid>
          )}
        </Grid>
      </div>
    </Popover>
  );
};

export default LargePopup;
